<mat-card>
  <mat-card-content>
    <div class=" head-container">
      <h1>{{'headerNav.profile.option3.settings' | translate}}</h1>
      <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.ProfileSetting)">
        <img class="trainingIcon" src="../../../assets/favicon/video.png">
      </div>
      <div class="popupHover">
        <ng-container *ngIf="isHidden">
          <div class="hideshow">
            <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
          </div>
        </ng-container>
      </div> -->
    </div>

    <div class="module-wrapper content-wrapper">
      <div class="border">
        <h3>{{'headerNav.profile.option3.language' | translate}}</h3>
        <br>
        <div class="row language">
          <div class="col-sm-2">{{'headerNav.profile.option3.selectLanguage' | translate}}</div>
          <div class="col-sm-3">
            <!-- <select class="form-control lang-dropdown" #selectedLang
            (change)="switchLang(selectedLang.value, $event)">
              <option *ngFor="let l of languageData" [value]="l.langId"
              [selected]="l === translate.currentLang" [attr.data-label]="l.languagecode">{{l.language}}</option>
            </select> -->
            <select class="form-control lang-dropdown" (change)="switchLang($event)" [(ngModel)]="selectedLang">
              <option *ngFor="let l of languageData" [value]="l.langId" [attr.data-label]="l.languagecode">{{l.language}}</option>
            </select>
          </div>
          <div class="col-sm-7"></div>
        </div>
      </div>

      <div class="border1">
        <h3>{{'headerNav.profile.option3.text' | translate}}</h3>
        <br>
        <form [formGroup]="changePwdForm" novalidate>
          <div class="row language">
            <div class="col-sm-2">{{'headerNav.profile.option3.oldPwd' | translate}} <span class="red-asterisk">*</span></div>
            <div class="col-sm-3">
              <input type="password" maxlength="21" class="form-control" formControlName="oldPassword">
              <div *ngIf="f.oldPassword.invalid && (f.oldPassword.dirty || f.oldPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.oldPassword.errors?.required">{{'headerNav.profile.option3.errorOldPwd1' | translate}}</div>
              </div>
            </div>
            <div class="col-sm-7"></div>
          </div>
          <br>
          <div class="row language">
            <div class="col-sm-2">{{'headerNav.profile.option3.newPwd' | translate}} <span class="red-asterisk">*</span></div>
            <div class="col-sm-3">
              <input type="password" maxlength="21" class="form-control" formControlName="newPassword">
              <div *ngIf="f.newPassword.invalid && (f.newPassword.dirty || f.newPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.newPassword.errors?.required">{{'headerNav.profile.option3.errorNewPwd1' | translate}}</div>
                <div *ngIf="f.newPassword.errors?.minlength ||
                  f.newPassword.errors?.maxlength ||
                  f.newPassword.errors?.pattern ||
                  changePwdForm.get('newPassword').hasError('passwordSameAsUsernameOrEmail')">
                  {{'headerNav.profile.option3.errorNewPwd2' | translate}}
                </div>
              </div>
            </div>
            <div class="col-sm-7"></div>
          </div>
          <br>
          <div class="row language">
            <div class="col-sm-2">{{'headerNav.profile.option3.conPwd' | translate}} <span class="red-asterisk">*</span></div>
            <div class="col-sm-3">
              <input type="password" maxlength="21" class="form-control" formControlName="confirmPassword">
              <div *ngIf="f.confirmPassword.invalid && (f.confirmPassword.dirty || f.confirmPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.confirmPassword.errors?.required">{{'headerNav.profile.option3.errorConPwd1' | translate}}</div>
                <div *ngIf="f.confirmPassword.errors?.minlength ||
                  f.confirmPassword.errors?.maxlength ||
                  f.confirmPassword.errors?.pattern ||
                  changePwdForm.get('confirmPassword').hasError('passwordSameAsUsernameOrEmail')">
                  {{'headerNav.profile.option3.errorConPwd2' | translate}}
                </div>
              </div>
            </div>
            <div class="col-sm-7"></div>
          </div> <br>
          <div class="row"  *ngIf="userData.isTwoFactorAuthentication">
            <div class="col-sm-2"></div>
            <div class="col-sm-3">
              <div>
                <button mat-flat-button class="btn-primary link" (click)="sendAuthenticationCode()"
                [disabled]="isEnable || !arePasswordsValid()">
                  {{'headerNav.profile.option3.sendCode' | translate}}
                </button>
              </div>
            </div>
          </div>
          <div class="row language" *ngIf="userData.isTwoFactorAuthentication">
            <div class="col-sm-2">{{'headerNav.profile.option3.otp' | translate}} <span class="red-asterisk">*</span></div>
            <div class="col-sm-3">
              <input type="text" class="form-control" formControlName="otp" maxlength="6"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
              (keydown.space)="$event.preventDefault()">
              <div *ngIf="f.otp.invalid && (f.otp.dirty || f.otp.touched)" class="alert alert-danger">
                <div *ngIf="f.otp.errors?.required">{{'headerNav.profile.option3.errorOTP' | translate}}</div>
              </div>
            </div>
            <div class="col-sm-7"></div>
          </div>
          <div class="row" *ngIf="userData.isTwoFactorAuthentication">
            <div class="col-sm-2"></div>
            <div class="col-sm-3">
              <div *ngIf="enableTimer" class="timer">
                <!-- <p>{{counter | minutesSeconds}}</p> -->
                {{minutes}} {{'headerNav.profile.option3.min' | translate}} {{seconds}} {{'headerNav.profile.option3.sec' | translate}}
              </div>
            </div>
          </div>
          <div class="row language">
            <div class="col-sm-5">
              <div class="button-wrapper">
                <button mat-flat-button class="btn-warn" [disabled]="!changePwdForm.valid"
                (click)="cancel()">{{'headerNav.profile.option3.btnCancel' | translate}}</button>
                <button mat-flat-button class="btn-primary" [disabled]="!changePwdForm.valid"
                (click)="submit()">{{'headerNav.profile.option3.btnSubmit' | translate}}</button>
              </div>
            </div>
            <div class="col-sm-7"></div>
          </div>
        </form>
      </div>
      <div class="border1" *ngIf="roleSer && roleSer.userRoles[0].rolesAssigned === accountAdmin">
        <h3>{{'headerNav.profile.option3.request' | translate}}</h3>
        <br>
        <div>
          <div class="">
              <mat-radio-group>
                <mat-radio-button value="user" (change)="load($event)" [checked]='true'>{{'headerNav.profile.option3.user' | translate}} </mat-radio-button>
                <mat-radio-button value="examinee" class="radio" (change)="load($event)">{{'headerNav.profile.option3.examinee' | translate}}</mat-radio-button>
              </mat-radio-group>
          </div>
        </div>
        <div class="no-user" *ngIf="noUsers">
          {{'headerNav.profile.option3.userErrMsg' | translate}}
        </div>
        <ng-container *ngIf="User && !noUsers">
          <div class="table-container">
            <table mat-table  matSort class="mat-elevation-z8" [dataSource]="lockedData">
              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column1' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.username}} </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column2' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.emailid}}</td>
              </ng-container>

              <ng-container matColumnDef="lockoutDate">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column3' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.lockoutdate}}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column4' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.accountstatus}}</td>
              </ng-container>

              <ng-container matColumnDef="temporaryPassStatus">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column5' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.temppasswordstatus}}</td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column6' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-flat-button class="btn-warn btn-resent" [disabled]="!row.issendpass" (click)="unlockUser(row)">{{row.action}}</button>
                  <!-- <button mat-flat-button class="btn-warn btn-resent" *ngIf="!rowStates[row.userid]" (click)="unlockUser(row)">{{'headerNav.profile.option3.btnUnlock' | translate}}2</button>
                  <button mat-flat-button class="btn-primary btn-resent" *ngIf="rowStates[row.userid]" (click)="unlockUser(row)">{{'headerNav.profile.option3.btnResent' | translate}}3</button> -->
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </table>
          </div>
          <div class="item-paginator">
            <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </ng-container>

        <div class="no-examinees" *ngIf="noExaminees">
          {{'headerNav.profile.option3.examineeErrMsg' | translate}}
        </div>
        <ng-container *ngIf="!User && !noExaminees">
          <div class="table-container">
            <table mat-table  matSort class="mat-elevation-z8" [dataSource]="lockedData">
              <ng-container matColumnDef="ExamineeName">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column7' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.examineename}} </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column2' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.emailid}} </td>
              </ng-container>

              <ng-container matColumnDef="lockoutDate">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column3' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.lockoutdate}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column4' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.accountstatus}} </td>
              </ng-container>

              <ng-container matColumnDef="temporaryPassStatus">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column5' | translate}}</th>
                <td mat-cell *matCellDef="let row">{{row.temppasswordstatus}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'headerNav.profile.option3.column6' | translate}}</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-flat-button class="btn-warn btn-resent" [disabled]="!row.issendpass" (click)="unlockExaminee(row)">{{row.action}}</button>
                  <!-- <button mat-flat-button class="btn-warn btn-resent" *ngIf="!rowStates[row.examineeid]" (click)="unlockExaminee(row)">{{'headerNav.profile.option3.btnUnlock' | translate}}1</button>
                  <button mat-flat-button class="btn-primary btn-resent" *ngIf="rowStates[row.examineeid]" (click)="unlockExaminee(row)">{{'headerNav.profile.option3.btnResent' | translate}}1</button> -->
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
              <tr  mat-row *matRowDef="let row; columns: displayedColumns1;">
            </table>
          </div>
          <div>
            <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </ng-container>

      </div>
    </div>
  </mat-card-content>
</mat-card>

<!--

<div class="main-content-wrapper ">
  <div class="content-wrapper">
    <div class="">
      <div class="container-fluid">
        <div class="row">
          <form [formGroup]="changePwdForm" novalidate>
            <div class="input-class">
              <label>{{'headerNav.profile.option3.oldPwd' | translate}}<span class="red-asterisk">*</span></label>
              <input matInput type="password" maxlength="21" class="form-control" formControlName="oldPassword">
              <div *ngIf="f.oldPassword.invalid && (f.oldPassword.dirty || f.oldPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.oldPassword.errors?.required">{{'headerNav.profile.option3.errorOldPwd1' | translate}}</div>
                <div *ngIf="f.oldPassword.errors?.minlength">{{'headerNav.profile.option3.errorOldPwd2' | translate}}</div>
                <div *ngIf="f.oldPassword.errors?.maxlength">{{'headerNav.profile.option3.errorOldPwd3' | translate}}</div>
                <div *ngIf="f.oldPassword.errors?.pattern">{{'headerNav.profile.option3.errorOldPwd4' | translate}}</div>
              </div>
            </div>
            <div class="input-class">
              <label>{{'headerNav.profile.option3.newPwd' | translate}}<span class="red-asterisk">*</span></label>
              <input matInput type="password" maxlength="21" class="form-control" formControlName="newPassword">
              <div *ngIf="f.newPassword.invalid && (f.newPassword.dirty || f.newPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.newPassword.errors?.required">{{'headerNav.profile.option3.errorNewPwd1' | translate}}</div>
                <div *ngIf="f.newPassword.errors?.minlength">{{'headerNav.profile.option3.errorNewPwd2' | translate}}</div>
                <div *ngIf="f.newPassword.errors?.maxlength">{{'headerNav.profile.option3.errorNewPwd3' | translate}}</div>
                <div *ngIf="f.newPassword.errors?.pattern">{{'headerNav.profile.option3.errorNewPwd4' | translate}}</div>
              </div>
            </div>
            <div class="input-class">
              <label>{{'headerNav.profile.option3.conPwd' | translate}}<span class="red-asterisk">*</span></label>
              <input matInput type="password" maxlength="21" class="form-control" formControlName="confirmPassword">
              <div *ngIf="f.confirmPassword.invalid && (f.confirmPassword.dirty || f.confirmPassword.touched)" class="alert alert-danger">
                <div *ngIf="f.confirmPassword.errors?.required">{{'headerNav.profile.option3.errorConPwd1' | translate}}</div>
                <div *ngIf="f.confirmPassword.errors?.minlength">{{'headerNav.profile.option3.errorConPwd2' | translate}}</div>
                <div *ngIf="f.confirmPassword.errors?.maxlength">{{'headerNav.profile.option3.errorConPwd3' | translate}}</div>
                <div *ngIf="f.confirmPassword.errors?.pattern">{{'headerNav.profile.option3.errorConPwd4' | translate}}</div>
              </div>
            </div>



            <div class="button-wrapper">
              <button mat-flat-button [ngClass]="changePwdForm.valid?'btn-primary':''" (click)="submit()"
                [disabled]="!changePwdForm.valid">{{'headerNav.profile.option3.btnSubmit' | translate}}</button>
              <button mat-flat-button class="btn-warn" (click)="cancel()">{{'headerNav.profile.option3.btnCancel' | translate}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div> -->
